export class FuelLevy {
    id          : number;
    month       : number;
    year        : number;
    local       : number;
    linehaul    : number;
    created_by  : number;
    updated_by  : number;
}
